import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=a76e0bac&scoped=true&"
import script from "./CustomerInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfo.vue?vue&type=style&index=0&id=a76e0bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76e0bac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a76e0bac')) {
      api.createRecord('a76e0bac', component.options)
    } else {
      api.reload('a76e0bac', component.options)
    }
    module.hot.accept("./CustomerInfo.vue?vue&type=template&id=a76e0bac&scoped=true&", function () {
      api.rerender('a76e0bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/components/CustomerInfo.vue"
export default component.exports